import React from 'react'

import { EuiButton, EuiDescriptionList, EuiDescriptionListDescription, EuiDescriptionListTitle, EuiFlexGroup, EuiFlexItem, EuiFlyoutBody, EuiFlyoutHeader, EuiLink, EuiSpacer, EuiTitle } from '@elastic/eui'

import { CampaignApprovalQueueItem } from 'api/interfaces'
import AcFlyout from 'components/AcFlyout'

import { formatApprovalBudget, formatApprovalDate, formatApprovalDateRange, formatDeliveryDevices, formatDeliveryFrequency, formatDeliveryInventory, formatDeliveryTargetCpm, formatFootprintSummary } from './campaignApprovalFormatting'

interface CampaignApprovalDetailFlyoutProps {
  item: CampaignApprovalQueueItem
  onClose: () => void
  onApprove: (item: CampaignApprovalQueueItem) => void
  onDisapprove: (item: CampaignApprovalQueueItem) => void
  onViewCampaign: (item: CampaignApprovalQueueItem) => void
  isApproving: boolean
}

export const CampaignApprovalDetailFlyout: React.FC<CampaignApprovalDetailFlyoutProps> = ({ item, onClose, onApprove, onDisapprove, onViewCampaign, isApproving }) => {
  const uploadedAudienceFileName = item.uploadedAudienceFileName

  return (
    <AcFlyout onClose={onClose} size='m' ownFocus>
      <EuiFlyoutHeader hasBorder>
        <EuiTitle size='m'>
          <h2>{item.campaignName}</h2>
        </EuiTitle>
      </EuiFlyoutHeader>
      <EuiFlyoutBody>
        <EuiDescriptionList>
          <EuiDescriptionListTitle>Account</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{item.accountName}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Type</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{item.campaignType}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Budget</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatApprovalBudget(item.budget, item.budgetFrequency)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Dates</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatApprovalDateRange(item.startDate, item.endDate)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Created by</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{item.createdBy}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Created</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatApprovalDate(item.created)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Audience list</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>
            {item.uploadedAudienceUrl && uploadedAudienceFileName ? (
              <EuiLink href={item.uploadedAudienceUrl} target='_blank'>
                {uploadedAudienceFileName}
              </EuiLink>
            ) : (
              'None'
            )}
          </EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Footprint</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatFootprintSummary(item.audienceFootprint)}</EuiDescriptionListDescription>
        </EuiDescriptionList>
        <EuiSpacer />
        <EuiTitle size='xs'>
          <h3>Delivery</h3>
        </EuiTitle>
        <EuiSpacer size='s' />
        <EuiDescriptionList type='column' compressed>
          <EuiDescriptionListTitle>Frequency</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatDeliveryFrequency(item.delivery)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Target CPM</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatDeliveryTargetCpm(item.delivery)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Inventory</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatDeliveryInventory(item.delivery)}</EuiDescriptionListDescription>

          <EuiDescriptionListTitle>Devices</EuiDescriptionListTitle>
          <EuiDescriptionListDescription>{formatDeliveryDevices(item.delivery)}</EuiDescriptionListDescription>
        </EuiDescriptionList>
        <EuiSpacer />
        <EuiLink onClick={() => onViewCampaign(item)}>View campaign</EuiLink>
        <EuiSpacer />
        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiButton size='s' fill color='primary' onClick={() => onApprove(item)} isLoading={isApproving}>
              Approve
            </EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton size='s' color='danger' onClick={() => onDisapprove(item)}>
              Disapprove
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutBody>
    </AcFlyout>
  )
}
